const menuLang = [
    {
        name:'dashboard',
        label:'Dashboard'
    },
    {
        name:'reportes',
        label:'REPORTES'
    },
    {
        name:'auditoria',
        label:'REPORTES AUDITORÍA'
    },
    {
        name:'auditoria-internal',
        label:'REPORTES AUDITORÍA-INTERNO'
    },
    {
        name:'maintenance',
        label:'Mantenimiento'
    },
    {
        name:'vta-val-inv',
        label:'Consumo / Inventario / D Rot'
    },
    {
        name:'dn-ssn-dp',
        label:'Distribución Numérica / Ponderada'
    },
    {
        name:'prices',
        label:'Precio Moda / Promedio'
    },
    {
        name:'vta-val-inv-internal',
        label:'Consumo / Inventario / D Rot'
    },
    {
        name:'dn-ssn-dp-internal',
        label:'Distribución Numérica / Ponderada'
    },
    {
        name:'prices-internal',
        label:'Precio Moda / Promedio'
    },
    {
        name:'logout',
        label:'Cerrar Sesión'
    },
    {
        name:'administration',
        label:'Administracion'
    },
    {
        name:'customer',
        label:'Clientes'
    },
    {
        name:'chequeos',
        label:'REPORTES CHEQUEOS'
    },
    {
        name:'distribution',
        label:'%Distribucion'
    },
    {
        name:'project-mass',
        label:'Proyecto MASS'
    },
    {
        name:'distribution-weighted',
        label:'%Distribucion Ponderada'
    },
    {
        name:'shopping-share',
        label:'Share de Compras'
    },
    {
        name:'visibility',
        label:'%Visibilidad'
    },
    {
        name:'purchase',
        label:'%Compra'
    },
    {
        name:'valued-purchase',
        label:'%Compra Valorizada'
    },
    {
        name:'price-average-moda',
        label:'Precios Promedios y Moda'
    },
    {
        name:'coexistence',
        label:'Convivencias'
    },
    {
        name:'multi-coexistence',
        label:'Multi Convivencias'
    },
    {
        name:'summary-distribution',
        label:'Resumen Distribucion'
    },
    {
        name:'histogram-prices',
        label:'Histograma de precios'
    },
    {
        name:'histogram-prices-register',
        label:'Histograma de precios por Registro'
    },
    {
        name:'overlay-marks',
        label:'Sobreposición de marcas'
    },
    {
        name:'breadth-sku-brands',
        label:'Amplitud de SKU/MARCAS'
    },
    //CHEQUEOS INTERNO
    {
        name:'chequeos-internal',
        label:'REPORTES CHEQUEOS INTERNO'
    },
    {
        name:'distribution-internal',
        label:'%Distribucion'
    },
    {
        name:'project-mass-internal',
        label:'Proyecto MASS'
    },
    {
        name:'distribution-weighted-internal',
        label:'%Distribucion Ponderada'
    },
    {
        name:'shopping-share-internal',
        label:'Share de Compras'
    },
    {
        name:'visibility-internal',
        label:'%Visibilidad'
    },
    {
        name:'purchase-internal',
        label:'%Compra'
    },
    {
        name:'valued-purchase-internal',
        label:'%Compra Valorizada'
    },
    {
        name:'price-average-moda-internal',
        label:'Precios Promedios y Moda'
    },
    {
        name:'coexistence-internal',
        label:'Convivencias'
    },
    {
        name:'multi-coexistence-internal',
        label:'Multi Convivencias'
    },
    {
        name:'summary-distribution-internal',
        label:'Resumen Distribucion'
    },
    {
        name:'histogram-prices-internal',
        label:'Histograma de precios'
    },
    {
        name:'histogram-prices-register-internal',
        label:'Histograma de precios por Registro'
    },
    {
        name:'overlay-marks-internal',
        label:'Sobreposición de marcas'
    },
    {
        name:'breadth-sku-brands-internal',
        label:'Amplitud de SKU/MARCAS'
    },
    {
        name:'breadth-attributes-brands-internal',
        label:'Amplitud Atributos'
    },
    {
        name:'generate-data',
        label:'Generar data'
    },
    {
        name:'vta-res-val-inv',
        label:'Resumen Consumo / Inventario / D Rot'
    },
    {
        name:'vta-res-val-inv-internal',
        label:'Resumen Consumo / Inventario / D Rot'
    },
    {
        name:'poll',
        label:'Modulo Encuesta'
    },
    {
        name:'request',
        label:'Consulta'
    },
    {
        name:'planning',
        label:'Planificación'
    },
    {
        name:'analysis',
        label:'Modulo Analisis'
    },
    {
        name:'samples',
        label:'Muestras y Estados de Negocios'
    },
    {
        name:'base',
        label:'Generar Base'
    },
    {
        name:'purchase-inventory',
        label:'Compras e inventarios'
    }
    
]

export default menuLang